import React from 'react'
import { CgFormatSlash } from 'react-icons/cg'

const Breadcrump: React.FC<BreadcrumpProps> = ({ data }) => {
    return (
        <div className='flex items-center space-x-1 font-medium text-base my-3 font-sans text-gray-200'>
            <p className='text-gray-300'>
                <a href={data[0].href}>
                    {data[0].item}
                </a>
            </p>
            {data.map((item, i) => {
                if (i > 0) return (
                    <div key={i} className="flex items-center space-x-1">
                        <CgFormatSlash className='text-xl' />
                        <p>
                            <a href={item.href}>{item.item}</a>
                        </p>
                    </div>
                )
            })}
        </div>
    )
}

export default Breadcrump